module.exports = __webpack_public_path__ + "static/media/active.aa3f3931.svg";